var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{style:({
            color: _vm.appearance.primaryColour,
        }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.clicked}},[_c('span',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }